// libraries
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

// copyright-policy
import Policy from '../components';

// shared
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setNavigationAnnouncement
  }, dispatch);
};

export default connect(null, mapDispatchToProps)(Policy);
